import './CSS/Estilo.css';
import {estiloGreen,estiloDark} from "./CSS/EstilosPagina";
import ToolBar from "./Componentes/SubComponentes/ToolBar";
import MenuDesplegable from "./Componentes/MenuDesplegable";
import {useState, useEffect, useCallback} from "react";
import Box from '@mui/system/Box';
import Grid from '@mui/material/Grid';
import WebTheme from "./Componentes/SubComponentes/WebTheme"
import {CajaTexto} from "./Componentes/SubComponentes/CajasTexto";
import {CajaTextoMediano} from "./Componentes/SubComponentes/CajasTexto";
import Footer from './Componentes/SubComponentes/Footer'

export default function OraxHome({modo}){

    const pages = ((modo === 'oraxulux')?
        [ 'Documentos', 'Contacto', 'Área privada']:
        [ 'Sobre nosotros', 'Noticias y Actividades','Contacto','Área privada']);
    const opciones = ['Dark','Green']
    const [estiloPagina,setEstiloPagina]=useState((localStorage.getItem('estilo') === 'Dark')?estiloDark
        :estiloGreen);

    useEffect(()=>{ 
        sessionStorage.clear();
        localStorage.removeItem('Gestion');
    },[]);

    const opcionesOnClick = useCallback((ev) => {

        let pulsado = ev.target.id;
        let estilo = (pulsado === 'Dark')?estiloDark:estiloGreen;
        setEstiloPagina(() => estilo);
        localStorage.setItem('estilo',pulsado);
    },[]);

    const textoVoluntariado = "Necesitamos personas que quieran darle mayor sentido a sus vidas ayudando a los demás." +
                               "\nNunca te exigiremos nada, puedes dedicar tu tiempo disponible sin compromiso." +
                                "\nContáctanos para mayor información.";

    const textoMiembros = "En Frater, encontraras: soporte de otras personas en un entorno completamente confiable," +
                          " actividades lúdicas y formativas y algo por desgracia no muy habitual en nuestra sociedad" +
                          " actual, espiritualidad Cristiana.";

    const textoSocial = "Estamos comprometidos en la lucha contra las injusticias sociales, problemas de accesibilidad"+
                        " y violación de derechos, que sufren las personas discapacitadas." +
                        "\nAsímismo, el apoyo mutuo entre las personas es una de las máximas de nuestro movimiento.";

    const colorFondoCajas = estiloPagina.background === 'black'?'#032E15':'#DCFCE7';
    const altoTextoCajas = '1.7em';
    const colorRotulos = (estiloPagina.background ==='black')?'white':'black';

    
    return(           
        <Box className='Cont' style={{background:estiloPagina.background}}>
            <Box className='ToolBar'>
                <ToolBar 
                    gadgets={[
                        <MenuDesplegable
                            key='1'
                            opciones={opciones}
                            opcionesOnClick={opcionesOnClick}>
                        </MenuDesplegable>]}
                    paginas={pages}
                    estilo ={estiloPagina}
                    modo = {modo}>
                </ToolBar>
            </Box>
            <Box className='Cabecera'>
                <h1 style={{margin:'auto',color:(estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreen,fontWeight:200}}>
                    Inicio
                </h1>
            </Box>
             <Box className = 'AreaNegocio' style={{background:estiloPagina.background}} >
                 { modo === 'frater' &&    <Grid container spacing = {2}>

                     {/*Foto portada*/}
                     <Grid item xs={12}>
                         <Box
                    component="img"
                    src="/frater_en_segovia_recortada.png"
                    alt="logoFrater"
                    sx={{
                    width: '97.5%',
                    ml: 1,
                        mr: 15,}}></Box>
                     </Grid>

                         <Box sx={{width:'100%'}}>
                             <CajaTextoMediano estiloPagina={estiloPagina} modo={'frater'} texto = {'Capacitados para vivir'}></CajaTextoMediano>
                         </Box>


                     {/*Caja voluntariado*/}
                     <Grid item xs={4}>
                         <Box sx={{width:'100%',height:'100%',border:(estiloPagina.background === 'black')?WebTheme.borderLines.lineaDark:WebTheme.borderLines.lineaGreen ,marginLeft: '1%', background:colorFondoCajas}}>
                             <label className={'rotuloWebMediano'} style={{display:'block',color:colorRotulos}}>Voluntariado </label>
                             <Box
                                 component="img"
                                 src="/voluntariado_frater.png"
                                 alt="logoFrater"
                                 sx={{
                                     width: '80%',
                                     mt: '1%',
                                     ml: '8%'

                                 }} >
                             </Box>
                             <CajaTexto estiloPagina={estiloPagina} altoLetra={altoTextoCajas} texto={textoVoluntariado}></CajaTexto>
                         </Box>
                     </Grid >

                     {/*Caja inscripciones*/}
                     <Grid item xs={4}>
                         <Box sx={{width:'100%',height:'100%', border:(estiloPagina.background === 'black')?WebTheme.borderLines.lineaDark:WebTheme.borderLines.lineaGreen,marginLeft: '1%', background:colorFondoCajas,display:'inline-block'}}>
                             <label className={'rotuloWebMediano'} style={{display:'block',color:colorRotulos}}>Miembros</label>
                             <Box
                                 component="img"
                                 src="/frater_miembros.png"
                                 alt="logoFrater"
                                 sx={{
                                     width: '35%',
                                     mt: '1%',
                                     ml:'32%'
                                 }} >
                             </Box>
                             <CajaTexto estiloPagina={estiloPagina} altoLetra={altoTextoCajas} texto = {textoMiembros}></CajaTexto>
                         </Box>
                     </Grid >

                     {/*Caja compromiso social*/}
                     <Grid item xs={3.9}>
                         <Box sx={{width:'100%',height:'100%', border:(estiloPagina.background === 'black')?WebTheme.borderLines.lineaDark:WebTheme.borderLines.lineaGreen ,ml: '1%',background:colorFondoCajas,display:'inline-block'}}>
                             <label className={'rotuloWebMediano'} style={{display:'block',color:colorRotulos}}>Compromiso social</label>
                             <Box
                                 component="img"
                                 src="/frater_solidaridad.png"
                                 alt="logoFrater"
                                 sx={{
                                     width: '33%',
                                     mt: '1%',
                                     ml:'33%'
                                 }} >
                             </Box>
                             <CajaTexto estiloPagina={estiloPagina} altoLetra={altoTextoCajas} texto={textoSocial}></CajaTexto>
                         </Box>
                     </Grid >

                 </Grid> }
            </Box> {/*Areanegocio*/}
            <Footer estilo={estiloPagina} modo={modo}></Footer>
        </Box>

    );
}
